// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Blog: (t, data?, options?) => t('enum.service.blog.name', data, options),
  DailyNews: (t, data?, options?) => t('enum.service.daily-news.name', data, options),
  LiveLessons: (t, data?, options?) => t('enum.service.live-lessons.name', data, options),
  LiveLessonsB2B: (t, data?, options?) => t('enum.service.live-lessons-b2-b.name', data, options),
  LiveLessonsB2S: (t, data?, options?) => t('enum.service.live-lessons-b2-s.name', data, options),
  QandA: (t, data?, options?) => t('enum.service.qand-a.name', data, options),
  StudyAbroad: (t, data?, options?) => t('enum.service.study-abroad.name', data, options),
  Tutor: (t, data?, options?) => t('enum.service.tutor.name', data, options),
  Words: (t, data?, options?) => t('enum.service.words.name', data, options),
  iKnow: (t, data?, options?) => t('enum.service.i-know.name', data, options),
  /* eslint-enable max-len */
};
